import * as z from 'zod';

z.config({
  customError: (issue) => {
    const { input, code, origin, expected, format, minimum, maximum } = issue;
    switch (code) {
      case 'too_small': {
        if (input === '') {
          return '入力してください';
        }
        if (Array.isArray(input) && input.length === 0) {
          return '選択してください';
        }
        return `${minimum}${origin === 'string' ? '文字' : ''}以上で入力してください`;
      }
      case 'too_big': {
        return `${maximum}${origin === 'string' ? '文字' : ''}以下で入力してください`;
      }
      case 'invalid_value': {
        if (input === '') {
          return '選択してください';
        }

        break;
      }
      case 'invalid_type': {
        if (expected === 'string') {
          if (input === undefined) {
            return '選択してください';
          }
        } else if (expected === 'number') {
          return '数字を入力してください';
        }

        break;
      }
      case 'invalid_format': {
        if (format === 'email') {
          if (input === '') {
            return 'メールアドレスを入力してください';
          }
          return 'メールアドレスが正しくありません';
        }
        if (format === 'url') {
          if (input === '') {
            return 'URLを入力してください';
          }
          return 'URLが正しくありません';
        }

        break;
      }
      // No default
    }
    return;
  },
});

export const validateZipcode = (value: string) => !value || /^\d{3}-?\d{4}$/.test(value);
